import Review from 'types/Review';
import apiRequest from './requestBase';

export async function deleteReview(review: Review) {
  return apiRequest({
    method: 'DELETE',
    url: `/my/reviews/${review.id}`
  });
}

/* Replies - admin only */

export async function createReply(review: Review, commentText: string) {
  const { id, trailId } = review;
  return apiRequest({
    params: { comment: commentText },
    method: 'POST',
    url: `/api/alltrails/trails/${trailId}/reviews/${id}/replies`
  });
}

export async function updateReply(review: Review, commentText: string) {
  const { id, trailId, replies } = review;
  return apiRequest({
    params: { comment: commentText },
    method: 'PUT',
    url: `/api/alltrails/trails/${trailId}/reviews/${id}/replies/${replies[0].id}`
  });
}

export async function deleteReply(review: Review) {
  const { id, trailId, replies } = review;
  return apiRequest({
    params: {},
    method: 'DELETE',
    url: `/api/alltrails/trails/${trailId}/reviews/${id}/replies/${replies[0].id}`
  });
}
